<style>
  .navbar {
  display: none !important;
}
</style>

  <div class="wrapper auth-wrapper">
    <div class="container">
      <div class="auth-page vertical-center">
        <div class="row no-gutters full-height">
          <div class="col-md-8 offset-md-2">
            <div class="auth-page-inner">
              <div class="row no-gutters">
                <div class="col-md-6">
                  <div class="auth-left-block height-1">
                   <div class="auth-inner vertical-center">
                      <div class="left-content">
                        <h2>Welcome to Bank Portal !</h2>
                        <ul class="list">
                          <li><i class="fa fa-database"></i>Social Community</li>
                          <li><i class="fa fa-database"></i>Real-Time Messaging</li>
                          <li><i class="fa fa-database"></i>Profile Showcase</li>
                        </ul>
                      </div>
                      <!-- <div class="copyright">
                        <p><small>© Copyright Bank Portal 2021. All Rights Reserved. Powered by <a href="https://imarkdigital.com/">iMark Digital.</a></small></p>
                      </div> -->
                   </div>
                    <!-- <img src="../../../../../../assets/img/login-bg.jpg" alt=""> -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="auth-right-block height-1">
                    <div class="auth-inner">
                      <!-- <div class="logo">
                        <img
                           src="../../../../../../assets/img/brand/imarkred.png" alt="..."/>
                      </div> -->
                      <h1 class="text-xs-center">Login to your account</h1>
                      <h1 *ngIf="deploymentType =='UAT'" class="text-xs-center" style ="color:darkred; font-size: 30px; font-style: normal;">{{deploymentType}}&nbsp; Version</h1>
                      <!-- <p class="text-xs-center">
                        <a [routerLink]="['/login']" *ngIf="authType == 'register'">Have an account?</a>
                        <a [routerLink]="['/register']" *ngIf="authType == 'login'">Need an account?</a>
                      </p> -->
                      <app-list-errors [errors]="errors"></app-list-errors>
                      <form [formGroup]="authForm" (ngSubmit)="submitForm()">
                        <fieldset >
                          <fieldset class="form-group">
                            <label class="font-size-h2 font-bold text-dark">Username</label>
                            <div class="form-control-wrap">
                              <i class="fa fa-user" aria-hidden="true"></i>
                              <input
                                formControlName="userName"
                                placeholder="Username"
                                class="form-control form-control-md"
                                type="text" [ngClass]="{ 'is-invalid': submitted && f.userName.errors }">
                                <div *ngIf="submitted && f.username.errors" >
                                  <span *ngIf="f.userName.errors.required" style="color: red;">Username is required</span>
                                </div>
                            </div>

                              <!-- *ngIf="authType == 'register' || authType == 'login'" /> -->
                          </fieldset>
                          <!-- <fieldset class="form-group">
                            <input
                              formControlName="email"
                              placeholder="Email"
                              class="form-control form-control-lg"
                              type="text" />
                          </fieldset> -->
                          <fieldset class="form-group">
                            <label class="font-size-h2 font-bold text-dark">Password</label>
                            <div class="form-control-wrap">
                              <i class="fa fa-lock" aria-hidden="true"></i>
                              <input
                                formControlName="password"
                                placeholder="Password"
                                class="form-control form-control-md"
                                type="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                                <div *ngIf="submitted && f.password.errors" >
                                  <span *ngIf="f.password.errors.required" style="color: red;">Password is required</span>
                              </div>
                            </div>
                          </fieldset>
                          <div class="form-group check-form clearfix">
                            <div class="switch-btn-wrapper float-left">
                                <label class="switch">
                                    <input type="checkbox" id="trending" name="trending">
                                    <span class="switch-btn"><i class="fa fa-check"></i></span>Remember Me</label>
                            </div>
                            <!-- <div class="float-right"><a href="#" class="forgot-psw">Forgot Password?</a></div> -->
                        </div>
                        <div >
                          <button *ngIf ="!submitted" class="btn btn-lg btn-neutral pull-xs-right"  type="submit">Sign In</button>
                          <button *ngIf ="submitted" [disabled]="submitted" class="btn btn-lg btn-neutral pull-xs-right"  type="submit">Signing In ...</button>
                        </div>

                        </fieldset>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="container page">
          <div class="row">
            <div class="col-md-6 offset-md-3 col-xs-12">
              <h1 class="text-xs-center">{{ title }}</h1>
              <p class="text-xs-center">
                <a [routerLink]="['/login']" *ngIf="authType == 'register'">Have an account?</a>
                <a [routerLink]="['/register']" *ngIf="authType == 'login'">Need an account?</a>
              </p>
              <app-list-errors [errors]="errors"></app-list-errors>
              <form [formGroup]="authForm" (ngSubmit)="submitForm()">
                <fieldset [disabled]="isSubmitting">
                  <fieldset class="form-group">
                    <input
                      formControlName="username"
                      placeholder="Username"
                      class="form-control form-control-lg"
                      type="text"/>
                      *ngIf="authType == 'register' || authType == 'login'" />
                  </fieldset>
                 <fieldset class="form-group">
                    <input
                      formControlName="email"
                      placeholder="Email"
                      class="form-control form-control-lg"
                      type="text" />
                  </fieldset>
                  <fieldset class="form-group">
                    <input
                      formControlName="password"
                      placeholder="Password"
                      class="form-control form-control-lg"
                      type="password" />
                  </fieldset>
                  <button class="btn btn-lg btn-primary pull-xs-right" [disabled]="!authForm.valid" type="submit">
                   Sign In
                  </button>
                </fieldset>
              </form>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>

